var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 827,
    height: 593,
    viewBox: "0 0 827 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.884 94.2467C591.631 76.7373 629.391 113.453 641.302 134C671.677 41.0933 606.461 2.23333 551.518 16.08C493.896 28.14 467.392 14.5911 455.034 0C458.757 38.7111 480.138 111.756 535.884 94.2467Z",
    fill: "#BAC3D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M506.191 94C494.472 131.195 486.431 210.584 548.025 230.58C574.283 236.829 612.112 222.546 626.353 185.946L637.034 162.29",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M637.034 138.56C639.687 134.147 646.022 128.173 650.142 139.578C654.262 150.984 643.12 159.945 637.034 163",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M642.034 142C643.434 142.933 645.486 145.64 642.501 149",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M552.034 121C551.125 127.407 546.852 141.776 537.034 148",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M551.034 156C549.83 153.333 543.537 148.711 537.034 148",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M580.034 110.007C584.717 109.861 594.873 111.854 598.034 121",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M511.034 119C511.909 114.85 515.934 106.643 525.034 107.012",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 526.534,
    cy: 123,
    rx: 4.5,
    ry: 6,
    fill: "#BAC3D7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 584.034,
    cy: 131,
    rx: 4,
    ry: 5,
    fill: "#BAC3D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M623.034 226C666.974 241.061 763.254 284.605 796.857 338.289C830.46 391.974 792.835 418.368 761.556 428.211L700.785 447",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M539.971 229.114L536.832 258.148M628.756 184L618.443 247.428M522.034 256.362C540.419 261.424 588.758 265.116 635.034 239.388",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M499.919 324C473.99 354.848 461.273 478.602 487.402 568.104C512.437 588.222 566.53 607.447 697.069 562.739C703.774 557.374 703.371 560.486 702.656 531.575C701.761 495.436 702.208 414.7 692.812 373.178",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M806.908 394C821.783 412.237 836.54 469.607 806.908 502.971C777.275 536.335 724.645 568.892 702.034 581M702.034 494.002L740.86 451.4C743.389 448.411 747.554 440.548 743.984 433.014",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M537.034 230.5C508.867 228 456.034 235 403.534 262C380.201 274 323.834 286.4 285.034 240C281.034 235.5 276.534 229 275.534 222C274.846 217.183 269.701 213.833 266.534 214M267.034 222C267.034 218.333 267.334 211.1 258.534 211.5M260.534 218.5C259.201 214.667 255.424 207.4 248.624 211M255.034 223C252.867 221.667 250.034 216.2 248.034 209C246.034 201.8 235.534 195.667 230.534 193.5C227.867 192.333 222.534 191.7 222.534 198.5C222.534 204.5 237.234 209.7 238.034 218.5C238.834 227.3 238.367 231.167 238.034 232C237.201 233.667 234.234 235.7 229.034 230.5C223.834 225.3 217.034 224 213.534 225C210.534 226 206.334 229.4 213.534 235C218.883 239.161 236.434 246.9 252.034 266.5C267.634 286.1 287.201 307 295.034 315C311.201 329.167 355.534 354.4 403.534 342",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M537.034 186.906C541.953 191.103 555.164 194.59 563.034 184",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M410.755 270C411.502 285.061 411.203 323.147 404.034 355",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M404.034 354.902C421.978 357.741 469.343 357.054 517.034 328",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M392.534 345C394.368 348.5 398.534 353 403.534 353",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222 146.522C211.485 127.065 179.563 90.0223 135.249 115.84C111.464 132.054 73.7342 181.17 113.091 247.921C121.103 260.892 148.017 283.766 191.581 271.494",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M202.378 156.826C199.991 149.073 189.489 133.867 166.575 135.067M149.993 136.568C138.812 135.942 117.281 141.895 120.597 170.707C123.914 199.519 119.969 204.721 117.582 203.72M111.929 206.722C108.914 207.847 104.618 207.922 101 206.722M104.392 224.354C106.025 225.229 110.12 226.455 113.437 224.354M118.713 222.853C125.12 221.478 136.652 212.349 131.526 186.839M133.034 174.083C131.15 169.456 129.265 158.927 136.803 153.825C144.34 148.723 152.757 147.947 156.023 148.198M172.982 148.198C180.268 150.073 195.142 157.576 196.348 172.583M200.117 178.21C201.624 180.586 204.187 186.989 202.378 193.591M194.087 227.73C193.207 239.485 186.851 265.396 168.46 275M151.124 273.499C155.395 272.249 164.842 267.497 168.46 258.493M172.982 252.866C178.133 247.489 184.288 226.605 181.65 190.965M188.057 186.839C187.806 179.961 184.439 164.854 172.982 159.452M161.299 156.826C153.636 157.701 141.982 164.729 145.094 187.964C148.109 210.473 146.601 212.349 145.094 215.35M141.325 220.978C139.315 227.355 132.657 240.786 122.105 243.487M136.803 252.866C135.421 254.492 131.3 257.893 125.873 258.493M136.803 265.246C146.224 263.745 163.241 255.579 168.46 229.606C173.359 205.221 172.982 200.344 170.721 185.713M173.359 177.46C173.61 174.333 172.53 168.156 166.198 168.456C159.867 168.756 159.54 176.834 160.169 180.836C162.807 197.643 158.963 233.958 145.094 242.361",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M334.5 84V8.5H258",
    stroke: "#BAC3D7",
    strokeOpacity: 0.6,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334.5 361.5V382.5H258",
    stroke: "#BAC3D7",
    strokeOpacity: 0.6,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5 84V8.5H81.5",
    stroke: "#BAC3D7",
    strokeOpacity: 0.6,
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5 307V382.5H81.5",
    stroke: "#BAC3D7",
    strokeOpacity: 0.6,
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcUnlock);
export default __webpack_public_path__ + "static/media/oc-unlock.25397ae6980ea2717bb85c4dc80a2f5a.svg";
export { ForwardRef as ReactComponent };